/**
 * mise利用状況のQuery Hook
 */

import { useQuery } from '@tanstack/react-query';
import { useAuthHeader } from '@/hooks/useAuth';
import { getUsageAuthenticated } from '@/lib/api/mise/usage';
import { usageKeys } from '../keys';
import { CACHE_TIME } from '../client';

/**
 * mise利用状況データを取得するQuery Hook
 * @param startDate 開始日 (YYYY-MM-DD)
 * @param endDate 終了日 (YYYY-MM-DD)
 * @param companyId 企業ID（省略時は全企業）
 */
export function useUsage(startDate: string, endDate: string, companyId?: string) {
  const { getAuthHeader, isLoading: authHeaderLoading, isAuthorized } = useAuthHeader();

  return useQuery({
    queryKey: usageKeys.data(startDate, endDate, companyId),
    queryFn: async () => {
      const authHeaders = getAuthHeader();
      return getUsageAuthenticated(authHeaders, {
        start_date: startDate,
        end_date: endDate,
        company_id: companyId || undefined,
      });
    },
    enabled: !authHeaderLoading && isAuthorized && !!startDate && !!endDate,
    staleTime: CACHE_TIME.ACCOUNTS_LIST,
  });
}
